import { useState } from 'react';
import { Button } from './ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from './ui/dropdown-menu';
import { Globe } from 'lucide-react';
import { useLanguage, SUPPORTED_LANGUAGES } from '../contexts/LanguageContext';

export default function LanguageSelector({ variant = 'default', showLabel = true }) {
  const { language, changeLanguage } = useLanguage();
  const [open, setOpen] = useState(false);

  const currentLang = SUPPORTED_LANGUAGES[language] || SUPPORTED_LANGUAGES.en;

  return (
    <DropdownMenu open={open} onOpenChange={setOpen}>
      <DropdownMenuTrigger asChild>
        <Button 
          variant={variant === 'ghost' ? 'ghost' : 'outline'} 
          size="sm"
          className="gap-2"
          data-testid="language-selector"
        >
          <Globe className="h-4 w-4" />
          {showLabel && <span className="hidden sm:inline">{currentLang.native}</span>}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48">
        {Object.entries(SUPPORTED_LANGUAGES).map(([code, lang]) => (
          <DropdownMenuItem
            key={code}
            onClick={() => {
              changeLanguage(code);
              setOpen(false);
            }}
            className={language === code ? 'bg-muted' : ''}
          >
            <span className="mr-2">{lang.flag}</span>
            <span className="flex-1">{lang.native}</span>
            {language === code && (
              <span className="text-xs text-muted-foreground">✓</span>
            )}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
